import { render, staticRenderFns } from "./StopWordsModal.vue?vue&type=template&id=33992f61&"
import script from "./StopWordsModal.vue?vue&type=script&lang=js&"
export * from "./StopWordsModal.vue?vue&type=script&lang=js&"
import style0 from "./StopWordsModal.vue?vue&type=style&index=0&id=33992f61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports